import { render, staticRenderFns } from "./NotificationTab.vue?vue&type=template&id=b20a9e78"
import script from "./NotificationTab.vue?vue&type=script&lang=js"
export * from "./NotificationTab.vue?vue&type=script&lang=js"
import style0 from "./NotificationTab.vue?vue&type=style&index=0&id=b20a9e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports